<template>
    <div class="layout_box" ref="layoutRef">
        <Navigation ref="navRef" />
        <div class="main_container">
            <keep-alive>
                <router-view v-if="$route.meta.keepAlive" />
            </keep-alive>
            <router-view v-if="!$route.meta.keepAlive" />
            <Footer ref="footerRef" />
        </div>
    </div>
</template>
<script>
import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';
export default {
    components: {
        Navigation,
        Footer,
    },
    data() {
        return {};
    },
    created() {},
    mounted() {},
    methods: {},
};
</script>
<style lang="scss" scoped>
.layout_box {
    min-width: 1110px;
    min-height: 100vh;
    background: #fff;
    display: flex;
    flex-direction: column;
    .main_container {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
}
</style>
